import { createContext, useContext } from 'react';
export var DataTableColumnRankContext = createContext(undefined);
export var useDataTableColumnRankContext = function () {
    return useContext(DataTableColumnRankContext);
};
//# sourceMappingURL=DataTableColumnRankContext.js.map